/** API usage fields: treat missing or invalid values as 0. */
export function usageAmount(value: unknown): number {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}
